// <wc-class-toggle data-toggle-class="active" data-toggle-element="#menu">...</wc-class-toggle>
// <wc-class-toggle></wc-class-toggle> (defaults to itself and 'active')
// see: section/wc-section-tabs.liquid for structure/usage
// Switches set of value in container (useful for tabs ect, try with CSS '+' sign selector)
class wcSwitchValues extends HTMLElement {
  constructor() {
    super();
    this.switchParent = this.dataset.wcSwitchParent ? this.closest(this.dataset.wcSwitchParent) : this;
    this.switchTriggers = this.querySelectorAll('[data-wc-switch-value]');
    this.watchTriggers();
  }
  watchTriggers() {
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-wc-switch-value]')) {
        const currentTrigger = event.target.closest('[data-wc-switch-value]');
        this.switchParent.dataset.wcCurrentValue = currentTrigger.dataset.wcSwitchValue;
        this.switchTriggers.forEach(switchTrigger => {
          switchTrigger === currentTrigger ? switchTrigger.classList.add('wc-active') : switchTrigger.classList.remove('wc-active');
        })
      }
    });
  }
}
window.customElements.define('wc-switch-values', wcSwitchValues);